import { StandardEvents } from '@shopify/events';
import { formatMoney, convertMoneyToMinorUnits } from '@theme/money-formatting';

/* Move footer social icons on mobile */
(function () {
  var socialLinks = document.querySelector('.sortabrick-footer-bottom__social-links');
  if (!socialLinks) return;

  var originalParent = socialLinks.parentNode;
  var originalNextSibling = socialLinks.nextSibling;
  var moved = false;

  function moveSocialLinks(matches) {
    if (matches && !moved) {
      var target = document.querySelector('.footer-about rte-formatter p:nth-child(2)');
      if (!target) return;
      target.insertAdjacentElement('afterend', socialLinks);
      moved = true;
    } else if (!matches && moved) {
      if (originalNextSibling) {
        originalParent.insertBefore(socialLinks, originalNextSibling);
      } else {
        originalParent.appendChild(socialLinks);
      }
      moved = false;
    }
  }

  var mediaQuery = window.matchMedia('(max-width: 749px)');
  moveSocialLinks(mediaQuery.matches);
  mediaQuery.addEventListener('change', function (event) {
    moveSocialLinks(event.matches);
  });
})();

/* Hero video play */
(function () {
  document.querySelectorAll('.sortabrick-hero-v2__play-button').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = button.previousElementSibling;
      if (!video || video.tagName !== 'VIDEO') return;
      video.setAttribute('controls', '');
      video.play();
      button.remove();
    });
  });
})();

/* Process video play */
(function () {
  document.querySelectorAll('.sortabrick-process__play-button').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = button.previousElementSibling;
      if (!video || video.tagName !== 'VIDEO') return;
      video.setAttribute('controls', '');
      video.play();
      button.remove();
    });
  });
})();

/* Countdown section */
function initSortabrickCountdown(root) {
  var target = new Date(root.dataset.targetDate).getTime();
  if (isNaN(target)) return;

  var wrapEl = root.querySelector('[data-countdown-timer]');
  var daysEl = root.querySelector('[data-countdown-days]');
  var hoursEl = root.querySelector('[data-countdown-hours]');
  var minutesEl = root.querySelector('[data-countdown-minutes]');
  var timer;

  function update() {
    var diff = target - Date.now();

    if (diff <= 0) {
      if (wrapEl) wrapEl.hidden = true;
      clearInterval(timer);
      return;
    }

    var totalMinutes = Math.floor(diff / 60000);
    var days = Math.floor(totalMinutes / 1440);
    var hours = Math.floor((totalMinutes % 1440) / 60);
    var minutes = totalMinutes % 60;

    if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
  }

  update();
  timer = setInterval(update, 30000);
}

document.querySelectorAll('.sortabrick-countdown').forEach(initSortabrickCountdown);

/* Press carousel */
(function () {
  function initSortabrickPress() {
    var el = document.querySelector('.sortabrick-press__swiper');
    if (!el) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(initSortabrickPress, 50);
      return;
    }

    new Swiper(el, {
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: 'row'
      },
      spaceBetween: 24,
      pagination: {
        el: '.sortabrick-press__pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.sortabrick-press__nav--next',
        prevEl: '.sortabrick-press__nav--prev'
      },
      breakpoints: {
        990: {
          slidesPerView: Number(el.dataset.slidesPerView) || 4,
          grid: {
            rows: 1
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickPress);
  } else {
    initSortabrickPress();
  }
})();

/* FAQ */
document.querySelectorAll('.sortabrick-faq__item').forEach(function (item) {
  var button = item.querySelector('.sortabrick-faq__item-summary');
  var answer = item.querySelector('[data-faq-answer]');
  if (!button || !answer) return;

  if (item.classList.contains('is-open')) {
    requestAnimationFrame(function () {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    });
  }

  item.addEventListener('click', function () {
    var isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      requestAnimationFrame(function () {
        answer.style.maxHeight = '0px';
      });
    } else {
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';

      var onEnd = function (e) {
        if (e.propertyName === 'max-height') {
          answer.style.maxHeight = 'none';
          answer.removeEventListener('transitionend', onEnd);
        }
      };
      answer.addEventListener('transitionend', onEnd);
    }
  });
});

/* Product accordion image lightbox */
(function () {
  function initSortabrickAccordionLightbox() {
    var images = document.querySelectorAll('.product-details .accordion .details-content img');
    if (!images.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'sortabrick-accordion-lightbox';
    dialog.innerHTML =
      '<button type="button" class="sortabrick-accordion-lightbox__close" aria-label="Close">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</button>' +
      '<img class="sortabrick-accordion-lightbox__image" alt="">';
    document.body.appendChild(dialog);

    var lightboxImage = dialog.querySelector('.sortabrick-accordion-lightbox__image');
    var closeButton = dialog.querySelector('.sortabrick-accordion-lightbox__close');

    function openLightbox(img) {
      lightboxImage.src = img.currentSrc || img.src;
      lightboxImage.alt = img.alt || '';
      dialog.showModal();
    }

    closeButton.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    images.forEach(function (img) {
      var wrapper = img.closest('.image-block') || img.parentElement;
      if (!wrapper) return;

      wrapper.classList.add('sortabrick-accordion-zoom-wrap');
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () {
        openLightbox(img);
      });

      var zoomButton = document.createElement('button');
      zoomButton.type = 'button';
      zoomButton.className = 'sortabrick-accordion-zoom-button';
      zoomButton.setAttribute('aria-label', 'Zoom image');
      zoomButton.innerHTML =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M7 10H13M10 7V13M21 21L15 15M3 10C3 10.9193 3.18106 11.8295 3.53284 12.6788C3.88463 13.5281 4.40024 14.2997 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.1705 16.8189 9.08075 17 10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.1705 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C9.08075 3 8.1705 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C4.40024 5.70026 3.88463 6.47194 3.53284 7.32122C3.18106 8.1705 3 9.08075 3 10Z" stroke="#282233" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

      zoomButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openLightbox(img);
      });

      wrapper.appendChild(zoomButton);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickAccordionLightbox);
  } else {
    initSortabrickAccordionLightbox();
  }
})();

/* Pairings carousel */
(function () {
  function initSwiperInstance(container) {
    var el = container.querySelector('.sortabrick-pairings__swiper');
    if (!el) return;

    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
      }
    }

    var prevBtn = container.querySelector('.sortabrick-pairings__nav-btn--prev');
    var nextBtn = container.querySelector('.sortabrick-pairings__nav-btn--next');

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      }
    });
  }

  function initSortabrickPairings() {
    var containers = document.querySelectorAll('.sortabrick-pairings');
    if (!containers.length) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(initSortabrickPairings, 50);
      return;
    }

    containers.forEach(initSwiperInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickPairings);
  } else {
    initSortabrickPairings();
  }

  document.addEventListener('theme-drawer:open', initSortabrickPairings);

  document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
    event.promise?.then(function () {
      initSortabrickPairings();
    }).catch(function () {});
  });
})();

/* Category badge tooltips, portaled to escape overflow-clipped/top-layer containers (cart drawer's dialog vs. document.body elsewhere) */
(function () {
  var configs = [
    { selector: '.sortabrick-pairings .sortabrick-category-badge-wrap', placement: 'top', align: 'start' },
    { selector: '.sortabrick-cart-item__top .sortabrick-category-badge-wrap', placement: 'bottom', align: 'end' }
  ];
  var combinedSelector = configs.map(function (c) { return c.selector; }).join(',');

  function findConfig(wrap) {
    return configs.filter(function (c) { return wrap.matches(c.selector); })[0];
  }

  function getTooltip(wrap) {
    var badge = wrap.querySelector('.sortabrick-category-badge');
    var tooltipId = badge && badge.getAttribute('aria-describedby');
    return tooltipId ? document.getElementById(tooltipId) : null;
  }

  function hideAll() {
    document.querySelectorAll('.sortabrick-category-badge__tooltip.is-visible').forEach(function (tooltip) {
      tooltip.classList.remove('is-visible');
    });
  }

  function showTooltipFor(wrap) {
    var config = findConfig(wrap);
    var badge = wrap.querySelector('.sortabrick-category-badge');
    var tooltip = getTooltip(wrap);
    if (!config || !badge || !tooltip) return;

    var portalTarget = wrap.closest('dialog[open]') || document.body;
    if (tooltip.parentElement !== portalTarget) {
      portalTarget.appendChild(tooltip);
    }

    hideAll();
    tooltip.className = 'sortabrick-category-badge__tooltip sortabrick-category-badge__tooltip--portal-' + config.placement;

    var rect = badge.getBoundingClientRect();
    var wantedTop = config.placement === 'bottom' ? rect.bottom + 12 : rect.top - 12;
    tooltip.style.setProperty('top', wantedTop + 'px', 'important');

    if (config.align === 'end') {
      var tooltipWidth = tooltip.offsetWidth;
      tooltip.style.setProperty('left', 'auto', 'important');
      tooltip.style.setProperty('right', (window.innerWidth - rect.right) + 'px', 'important');
      tooltip.style.setProperty('--arrow-offset', (tooltipWidth - rect.width / 2 - 6) + 'px');
    } else {
      tooltip.style.setProperty('right', 'auto', 'important');
      tooltip.style.setProperty('left', rect.left + 'px', 'important');
      tooltip.style.setProperty('--arrow-offset', (rect.width / 2 - 6) + 'px');
    }

    tooltip.classList.add('is-visible');
  }

  document.addEventListener('mouseover', function (event) {
    var wrap = event.target.closest(combinedSelector);
    if (wrap) showTooltipFor(wrap);
  });

  document.addEventListener('focusin', function (event) {
    var wrap = event.target.closest(combinedSelector);
    if (wrap) showTooltipFor(wrap);
  });

  document.addEventListener('mouseout', function (event) {
    if (event.target.closest(combinedSelector)) hideAll();
  });

  document.addEventListener('focusout', function (event) {
    if (event.target.closest(combinedSelector)) hideAll();
  });

  var wasOpenBeforeClick = false;

  document.addEventListener('pointerdown', function (event) {
    var wrap = event.target.closest(combinedSelector);
    if (!wrap) return;
    var tooltip = getTooltip(wrap);
    wasOpenBeforeClick = !!(tooltip && tooltip.classList.contains('is-visible'));
  });

  document.addEventListener('click', function (event) {
    var wrap = event.target.closest(combinedSelector);
    if (wrap && wasOpenBeforeClick) hideAll();
  });
})();

(function () {
  var wrapSelector = '.sortabrick-product-top .sortabrick-category-badge-wrap, .sortabrick-card-meta .sortabrick-category-badge-wrap';
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function closeAll() {
    var opened = document.querySelectorAll(wrapSelector.split(', ').map(function (s) { return s + '.is-open'; }).join(', '));
    opened.forEach(function (wrap) {
      wrap.classList.remove('is-open');
    });
    return opened.length > 0;
  }

  window.addEventListener('click', function (event) {
    if (!mobileQuery.matches) return;

    var wrap = event.target.closest(wrapSelector);

    if (!wrap) {
      if (closeAll()) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }

    var badge = wrap.querySelector('.sortabrick-category-badge[tabindex="0"]');
    if (!badge) return;

    var isOpen = wrap.classList.contains('is-open');
    closeAll();
    if (!isOpen) {
      wrap.classList.add('is-open');
    }
  }, true);
})();

/* Product tabs */
(function () {
  function initSortabrickProductTabs() {
    document.querySelectorAll('[data-tabs-nav]').forEach(function (nav) {
      var container = nav.closest('.sortabrick-product-tabs');
      if (!container) return;

      var tabs = nav.querySelectorAll('.sortabrick-product-tabs__tab');
      var panels = container.querySelectorAll('[data-tabs-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-tabs-target');

          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            t.tabIndex = isActive ? 0 : -1;
          });

          panels.forEach(function (panel) {
            var isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickProductTabs);
  } else {
    initSortabrickProductTabs();
  }
})();

(function () {
  function initSortabrickProductTabsViewToggle() {
    document.querySelectorAll('[data-view-toggle]').forEach(function (toggle) {
      var container = toggle.closest('.sortabrick-product-tabs');
      if (!container) return;

      var buttons = toggle.querySelectorAll('.sortabrick-product-tabs__view-btn');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });

          container.classList.toggle('is-single-column', btn.getAttribute('data-view') === 'single');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickProductTabsViewToggle);
  } else {
    initSortabrickProductTabsViewToggle();
  }
})();

/* Recommendations */
(function () {
  function initSortabrickRecommendations() {
    var el = document.querySelector('.sortabrick-recommendations__swiper');
    if (!el) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(initSortabrickRecommendations, 50);
      return;
    }

    new Swiper(el, {
      slidesPerView: 1.25,
      spaceBetween: 12,
      pagination: {
        el: '.sortabrick-recommendations__pagination',
        clickable: true
      },
      breakpoints: {
        750: {
          enabled: false
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickRecommendations);
  } else {
    initSortabrickRecommendations();
  }
})();

/* Price filter dual-range slider */
(function () {
  function extractMoneyPlaceholder(format) {
    var match = format.match(/{{\s*\w+\s*}}/);
    return match ? match[0] : '{{amount}}';
  }

  function initSlider(slider) {
    if (slider.dataset.sliderInit === 'true') return;
    slider.dataset.sliderInit = 'true';

    var component = slider.closest('price-facet-component');
    if (!component) return;

    var minRange = slider.querySelector('[data-slider-range="min"]');
    var maxRange = slider.querySelector('[data-slider-range="max"]');
    var fill = slider.querySelector('[data-slider-fill]');
    var minInput = component.querySelector('[ref="minInput"]');
    var maxInput = component.querySelector('[ref="maxInput"]');
    if (!minRange || !maxRange || !fill || !minInput || !maxInput) return;

    var sliderMax = parseFloat(slider.dataset.sliderMax) || 0;
    var currency = component.dataset.currency || 'USD';
    var moneyFormat = extractMoneyPlaceholder(component.dataset.moneyFormat || '{{amount}}');

    function updateFill() {
      var minVal = parseFloat(minRange.value);
      var maxVal = parseFloat(maxRange.value);
      if (minVal > maxVal) {
        var swap = minRange.value;
        minRange.value = maxRange.value;
        maxRange.value = swap;
        minVal = parseFloat(minRange.value);
        maxVal = parseFloat(maxRange.value);
      }
      var minPercent = sliderMax ? (minVal / sliderMax) * 100 : 0;
      var maxPercent = sliderMax ? (maxVal / sliderMax) * 100 : 100;
      fill.style.left = minPercent + '%';
      fill.style.right = (100 - maxPercent) + '%';
      minRange.style.zIndex = minVal > sliderMax - 1 ? 2 : 1;
    }

    function formatValue(value) {
      var minorUnits = convertMoneyToMinorUnits(value.toFixed(2), currency) ?? 0;
      return formatMoney(minorUnits, moneyFormat, currency);
    }

    function updateInputsDisplay() {
      minInput.value = formatValue(parseFloat(minRange.value));
      maxInput.value = formatValue(parseFloat(maxRange.value));
    }

    [minRange, maxRange].forEach(function (range) {
      range.addEventListener('input', function () {
        updateFill();
        updateInputsDisplay();
      });
    });

    updateFill();
  }

  function initSortabrickPriceSliders() {
    document.querySelectorAll('[data-price-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickPriceSliders);
  } else {
    initSortabrickPriceSliders();
  }

  function reinitAfterRender(event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(initSortabrickPriceSliders);
    } else {
      initSortabrickPriceSliders();
    }
  }

  document.addEventListener('theme-drawer:open', initSortabrickPriceSliders);
  document.addEventListener('shopify:search:update', reinitAfterRender, true);
  document.addEventListener('shopify:collection:update', reinitAfterRender, true);
})();

/* Sort by wrapper forwards clicks anywhere in the pill to the native sorting summary */
(function () {
  var wasOpenBeforeClick = false;

  document.addEventListener('pointerdown', function (event) {
    var wrapper = event.target.closest('.sortabrick-sort-wrapper');
    if (!wrapper) return;
    var details = wrapper.querySelector('details[data-auto-close-details]');
    wasOpenBeforeClick = !!(details && details.open);
  });

  document.addEventListener('click', function (event) {
    var wrapper = event.target.closest('.sortabrick-sort-wrapper');
    if (!wrapper) return;
    if (event.target.closest('.facets__summary')) return;
    if (event.target.closest('floating-panel-component')) return;
    if (wasOpenBeforeClick) return;
    var summary = wrapper.querySelector('.facets__summary');
    if (!summary) return;
    setTimeout(function () {
      summary.click();
    }, 0);
  });
})();

/* Wishlist */
(function () {
  var STORAGE_KEY = 'sortabrick:wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('sortabrick:wishlist:change', { detail: { handles: handles } }));
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      setWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index !== -1) {
      list.splice(index, 1);
      setWishlist(list);
    }
  }

  function toggleWishlist(handle) {
    if (isWishlisted(handle)) {
      removeFromWishlist(handle);
      return false;
    }
    addToWishlist(handle);
    return true;
  }

  function syncWishlistButtons(scope) {
    var root = scope || document;
    var list = getWishlist();
    var buttons =
      root.matches && root.matches('[data-wishlist-toggle]')
        ? [root]
        : root.querySelectorAll('[data-wishlist-toggle]');
    buttons.forEach(function (button) {
      var handle = button.dataset.productHandle;
      var active = !!handle && list.indexOf(handle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncHeaderWishlistIcon() {
    var hasItems = getWishlist().length > 0;
    document.querySelectorAll('.action__wishlist').forEach(function (link) {
      link.classList.toggle('has-items', hasItems);
    });
    document.querySelectorAll('.icon-wishlist-menu').forEach(function (icon) {
      icon.classList.toggle('has-items', hasItems);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    var handle = button.dataset.productHandle;
    if (!handle) return;
    toggleWishlist(handle);
  });

  document.addEventListener('sortabrick:wishlist:change', function () {
    syncWishlistButtons();
    syncHeaderWishlistIcon();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      syncWishlistButtons();
      syncHeaderWishlistIcon();
    }
  });

  function initWishlistToggles() {
    syncWishlistButtons();
    syncHeaderWishlistIcon();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistToggles);
  } else {
    initWishlistToggles();
  }

  var wishlistButtonObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-wishlist-toggle]')) {
          syncWishlistButtons(node);
        } else if (node.querySelector && node.querySelector('[data-wishlist-toggle]')) {
          syncWishlistButtons(node);
        }
        if (
          (node.matches && node.matches('.action__wishlist, .icon-wishlist-menu')) ||
          (node.querySelector && node.querySelector('.action__wishlist, .icon-wishlist-menu'))
        ) {
          syncHeaderWishlistIcon();
        }
      }
    }
  });
  wishlistButtonObserver.observe(document.documentElement, { childList: true, subtree: true });

  var wishlistIconAttrObserver = new MutationObserver(function (mutations) {
    var hasItems = getWishlist().length > 0;
    mutations.forEach(function (mutation) {
      var target = mutation.target;
      if (!(target instanceof Element)) return;
      if (!target.matches('.action__wishlist, .icon-wishlist-menu')) return;
      if (target.classList.contains('has-items') !== hasItems) {
        target.classList.toggle('has-items', hasItems);
      }
    });
  });
  wishlistIconAttrObserver.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  function getOrCreateEmptyWishlistMessage() {
    var existing = document.querySelector('.sortabrick-wishlist-empty');
    if (existing) return existing;

    var data = document.body.dataset;
    var message = document.createElement('div');
    message.className = 'sortabrick-wishlist-empty';
    message.hidden = true;

    var iconTemplate = document.getElementById('sortabrick-empty-wishlist-icon');
    if (iconTemplate && iconTemplate.innerHTML.trim() !== '') {
      var icon = document.createElement('div');
      icon.className = 'sortabrick-wishlist-empty__icon';
      icon.innerHTML = iconTemplate.innerHTML;
      message.appendChild(icon);
    }

    var heading = document.createElement('h2');
    heading.className = 'sortabrick-wishlist-empty__heading';
    heading.textContent = data.sortabrickEmptyWishlistHeading || 'No bricks saved yet';
    message.appendChild(heading);

    var text = document.createElement('p');
    text.className = 'sortabrick-wishlist-empty__text';
    text.textContent = data.sortabrickEmptyWishlistText || 'Your wishlist is empty.';
    message.appendChild(text);

    var primaryText = data.sortabrickEmptyWishlistPrimaryText;
    var secondaryText = data.sortabrickEmptyWishlistSecondaryText;

    if (primaryText || secondaryText) {
      var actions = document.createElement('div');
      actions.className = 'sortabrick-wishlist-empty__actions';

      if (primaryText) {
        var primaryLink = document.createElement('a');
        primaryLink.className = 'button sortabrick-wishlist-empty__button';
        primaryLink.href = data.sortabrickEmptyWishlistPrimaryUrl || '/collections/all';
        primaryLink.textContent = primaryText;
        actions.appendChild(primaryLink);
      }

      if (secondaryText) {
        var secondaryLink = document.createElement('a');
        secondaryLink.className = 'button button-secondary sortabrick-wishlist-empty__button';
        secondaryLink.href = data.sortabrickEmptyWishlistSecondaryUrl || '/';
        secondaryLink.textContent = secondaryText;
        actions.appendChild(secondaryLink);
      }

      message.appendChild(actions);
    }

    var reference = document.querySelector('.main-collection-grid__empty');
    var container = reference ? reference.parentNode : document.querySelector('#ResultsList');
    if (container) {
      if (reference) {
        container.insertBefore(message, reference);
      } else {
        container.appendChild(message);
      }
    }
    return message;
  }

  function initWishlistPage() {
    if (document.body.dataset.sortabrickWishlistPage !== 'true') return;

    var handles = getWishlist();
    var emptyMessage = getOrCreateEmptyWishlistMessage();
    var nativeEmptyState = document.querySelector('.main-collection-grid__empty');
    if (nativeEmptyState) nativeEmptyState.hidden = true;

    var grid = document.querySelector('[data-testid="product-grid"]');

    if (handles.length === 0) {
      emptyMessage.hidden = false;
      if (grid) grid.innerHTML = '';
      return;
    }

    emptyMessage.hidden = true;

    if (!grid) {
      var container = nativeEmptyState ? nativeEmptyState.parentNode : emptyMessage.parentNode;
      if (!container) return;
      grid = document.createElement('ul');
      grid.className = 'product-grid product-grid--grid';
      grid.setAttribute('role', 'list');
      grid.setAttribute('data-testid', 'product-grid');
      container.insertBefore(grid, nativeEmptyState || emptyMessage);
    } else {
      grid.innerHTML = '';
    }

    var pending = handles.length;
    var rendered = 0;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '?view=card')
        .then(function (response) {
          if (!response.ok) throw new Error('product not found');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('product-card');
          if (!card) return;
          var item = document.createElement('li');
          item.className = 'product-grid__item';
          item.appendChild(card);
          grid.appendChild(item);
          rendered += 1;
          syncWishlistButtons(item);
        })
        .catch(function () {
          removeFromWishlist(handle);
        })
        .finally(function () {
          pending -= 1;
          if (pending === 0 && rendered === 0) {
            emptyMessage.hidden = false;
          }
        });
    });
  }

  document.addEventListener('sortabrick:wishlist:change', function () {
    if (document.body.dataset.sortabrickWishlistPage !== 'true') return;
    if (getWishlist().length > 0) return;
    var emptyMessage = getOrCreateEmptyWishlistMessage();
    emptyMessage.hidden = false;
    var grid = document.querySelector('[data-testid="product-grid"]');
    if (grid) grid.innerHTML = '';
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }

  function reinitWishlistPageAfterRender(event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(function () {
        initWishlistPage();
        syncHeaderWishlistIcon();
      });
    } else {
      initWishlistPage();
      syncHeaderWishlistIcon();
    }
  }

  document.addEventListener('shopify:search:update', reinitWishlistPageAfterRender, true);
  document.addEventListener('shopify:collection:update', reinitWishlistPageAfterRender, true);
})();

/* Video section play */
(function () {
  document.querySelectorAll('.sortabrick-video__play-button').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = button.previousElementSibling;
      if (!video || video.tagName !== 'VIDEO') return;
      video.setAttribute('controls', '');
      video.play();
      button.remove();
    });
  });
})();

/* Video v2 play */
document.querySelectorAll('.sortabrick-video-v2__play-button').forEach(function (button) {
  button.addEventListener('click', function () {
    var video = button.previousElementSibling;
    if (!video || video.tagName !== 'VIDEO') return;
    video.setAttribute('controls', '');
    video.play();
    button.remove();
  });
});

/* Brick calculator (payout) */
document.querySelectorAll('[data-sortabrick-payout-calculator]').forEach(function (calculator) {
  var input = calculator.querySelector('[data-sortabrick-payout-calculator-weight]');
  if (!input) return;

  var partsRate = parseFloat(calculator.dataset.partsRate) || 0;
  var minifigRate = parseFloat(calculator.dataset.minifigRate) || 0;
  var minifigPercentage = parseFloat(calculator.dataset.minifigPercentage) || 0;
  var currencySymbol = calculator.dataset.currencySymbol || '';
  var weightUnit = calculator.dataset.weightUnit || '';

  var partsBreakdownEl = calculator.querySelector('[data-sortabrick-payout-calculator-parts-breakdown]');
  var minifigBreakdownEl = calculator.querySelector('[data-sortabrick-payout-calculator-minifig-breakdown]');
  var partsDetailEl = calculator.querySelector('[data-sortabrick-payout-calculator-parts-detail]');
  var minifigDetailEl = calculator.querySelector('[data-sortabrick-payout-calculator-minifig-detail]');
  var partsPayoutEl = calculator.querySelector('[data-sortabrick-payout-calculator-parts-payout]');
  var minifigPayoutEl = calculator.querySelector('[data-sortabrick-payout-calculator-minifig-payout]');
  var totalEl = calculator.querySelector('[data-sortabrick-payout-calculator-total]');

  function formatMoney(value) {
    return currencySymbol + value.toFixed(2);
  }

  function update() {
    var totalWeight = parseFloat(input.value) || 0;
    var minifigWeight = totalWeight * (minifigPercentage / 100);
    var partsWeight = totalWeight - minifigWeight;

    var partsPayout = partsWeight * partsRate;
    var minifigPayout = minifigWeight * minifigRate;
    var totalPayout = partsPayout + minifigPayout;

    if (partsBreakdownEl) partsBreakdownEl.textContent = partsWeight.toFixed(2) + ' ' + weightUnit;
    if (minifigBreakdownEl) minifigBreakdownEl.textContent = '~' + minifigWeight.toFixed(2) + ' ' + weightUnit;
    if (partsDetailEl) partsDetailEl.textContent = partsWeight.toFixed(2);
    if (minifigDetailEl) minifigDetailEl.textContent = minifigWeight.toFixed(2);
    if (partsPayoutEl) partsPayoutEl.textContent = formatMoney(partsPayout);
    if (minifigPayoutEl) minifigPayoutEl.textContent = formatMoney(minifigPayout);
    if (totalEl) totalEl.textContent = formatMoney(totalPayout);
  }

  input.addEventListener('input', update);
  update();
});

/* Article share button */
document.querySelectorAll('[data-sortabrick-article-share]').forEach(function (button) {
  var label = button.querySelector('[data-sortabrick-article-share-label]');
  var defaultText = label ? label.textContent : '';

  button.addEventListener('click', function () {
    var url = button.dataset.shareUrl;
    var title = button.dataset.shareTitle;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }

    if (navigator.clipboard && label) {
      navigator.clipboard.writeText(url).then(function () {
        label.textContent = 'Link copied';
        setTimeout(function () {
          label.textContent = defaultText;
        }, 2000);
      });
    }
  });
});

/* Email popup */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[href="#sortabrick-email-popup"], [href$="#sortabrick-email-popup"]');
  if (!trigger) return;

  var popup = document.getElementById('sortabrick-email-popup');
  if (!popup || typeof popup.showDialog !== 'function') return;

  event.preventDefault();
  popup.showDialog();
});

document.addEventListener('click', function (event) {
  var dialog = document.querySelector('#sortabrick-email-popup dialog');
  if (!dialog || !dialog.open) return;

  if (event.target === dialog) {
    document.getElementById('sortabrick-email-popup').closeDialog();
  }
});

/* Results carousel */
(function () {
  function initSortabrickResults() {
    var outerEl = document.querySelector('.sortabrick-results__swiper');
    if (!outerEl) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(initSortabrickResults, 50);
      return;
    }

    new Swiper(outerEl, {
      slidesPerView: 1.1,
      spaceBetween: 12,
      pagination: {
        el: '.sortabrick-results__pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.sortabrick-results__nav--next',
        prevEl: '.sortabrick-results__nav--prev'
      },
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 24
        },
        1100: {
          slidesPerView: Number(outerEl.dataset.slidesPerView) || 4,
          spaceBetween: 24
        }
      }
    });

    document.querySelectorAll('.sortabrick-results__card').forEach(function (card) {
      var cardEl = card.querySelector('.sortabrick-results__card-swiper');
      if (!cardEl) return;

      var prevBtn = card.querySelector('.sortabrick-results__card-nav--prev');
      var nextBtn = card.querySelector('.sortabrick-results__card-nav--next');
      var paginationEl = card.querySelector('.sortabrick-results__card-pagination');

      new Swiper(cardEl, {
        slidesPerView: 1,
        loop: cardEl.querySelectorAll('.swiper-slide').length > 1,
        pagination: {
          el: paginationEl,
          clickable: true
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickResults);
  } else {
    initSortabrickResults();
  }
})();

/* Sortabrick restore calculator */
(function () {
  function roundTo10(value) {
    return Math.round(value / 10) * 10;
  }

  function formatKg(value) {
    var rounded = Math.round(value * 10) / 10;
    return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
  }

  function initSortabrickCalculator() {
    var cards = document.querySelectorAll('[data-sortabrick-calculator]');

    cards.forEach(function (card) {
      var input = card.querySelector('[data-sortabrick-calculator-kg]');
      var analysisValue = card.querySelector('[data-sortabrick-calculator-analysis-value]');
      var analysisNote = card.querySelector('[data-sortabrick-calculator-analysis-note]');
      var sortingValue = card.querySelector('[data-sortabrick-calculator-sorting-value]');
      var sortingNote = card.querySelector('[data-sortabrick-calculator-sorting-note]');
      var sortingDescription = card.querySelector('[data-sortabrick-calculator-sorting-description]');
      var missingValue = card.querySelector('[data-sortabrick-calculator-missing-value]');
      var totalValue = card.querySelector('[data-sortabrick-calculator-total-value]');
      var calloutText = card.querySelector('[data-sortabrick-calculator-callout]');

      var analysisRate = parseFloat(card.dataset.analysisRate) || 0;
      var sortingRate = parseFloat(card.dataset.sortingRate) || 0;
      var missingRate = parseFloat(card.dataset.missingRate) || 0;
      var usefulShare = (parseFloat(card.dataset.usefulShare) || 0) / 100;
      var multiplier = parseFloat(card.dataset.multiplier) || 1;

      var sortingDescriptionTemplate = sortingDescription ? sortingDescription.textContent.trim() : '';
      var calloutTemplate = calloutText ? calloutText.textContent.trim() : '';

      function update() {
        var kg = parseFloat(input.value) || 0;
        var sortedKg = kg * usefulShare;

        var rawAnalysis = kg * analysisRate;
        var rawSorting = sortedKg * sortingRate;
        var rawMissing = kg * missingRate;
        var rawTotal = rawAnalysis + rawSorting + rawMissing;

        if (analysisValue) analysisValue.textContent = '€' + rawAnalysis.toFixed(2);
        if (analysisNote) analysisNote.textContent = formatKg(kg) + ' kg × €' + analysisRate.toFixed(2) + '/kg';

        if (sortingValue) sortingValue.textContent = '~€' + roundTo10(rawSorting);
        if (sortingNote) sortingNote.textContent = '~' + formatKg(sortedKg) + ' kg × €' + sortingRate.toFixed(2) + '/kg';
        if (sortingDescription && sortingDescriptionTemplate) {
          sortingDescription.textContent = sortingDescriptionTemplate
            .replace('[sorted_kg]', formatKg(sortedKg))
            .replace('[kg]', formatKg(kg));
        }

        if (missingValue) missingValue.textContent = '~€' + roundTo10(rawMissing);

        if (totalValue) totalValue.textContent = '~€' + roundTo10(rawTotal);

        if (calloutText && calloutTemplate) {
          calloutText.textContent = calloutTemplate.replace('[multiplier]', multiplier + '×');
        }
      }

      if (input) {
        input.addEventListener('input', update);
        update();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickCalculator);
  } else {
    initSortabrickCalculator();
  }
})();

/* Sortabrick restore popup */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[href="#sample-report"], [href$="#sample-report"]');
  if (!trigger) return;

  var popup = document.getElementById('sample-report');
  if (!popup || typeof popup.showDialog !== 'function') return;

  event.preventDefault();
  popup.showDialog();
});

document.addEventListener('click', function (event) {
  var dialogEl = document.querySelector('#sample-report dialog');
  if (!dialogEl || !dialogEl.open) return;

  if (event.target === dialogEl) {
    document.getElementById('sample-report').closeDialog();
  }
});

/* Sortabrick sell form v2 — orders.br1ck.com Bulk API integration */
(function () {
  var MAX_PHOTO_BYTES = 20 * 1024 * 1024; // API limit is 20 MB

  function initSortabrickSellFormV2() {
    var forms = document.querySelectorAll('[data-sortabrick-sell-form-v2]');

    forms.forEach(function (form) {
      var tokenUrl = form.dataset.tokenUrl;
      var uploadUrl = form.dataset.uploadUrl;
      var submitUrl = form.dataset.submitUrl;

      var fileInput = form.querySelector('[data-sortabrick-file-input]');
      var dropzone = form.querySelector('[data-sortabrick-dropzone]');
      var dropzoneText = form.querySelector('[data-sortabrick-dropzone-text]');
      var uploadError = form.querySelector('[data-sortabrick-upload-error]');
      var submitError = form.querySelector('[data-sortabrick-submit-error]');
      var submitSuccess = form.querySelector('[data-sortabrick-submit-success]');
      var submitButton = form.querySelector('[data-sortabrick-submit-button]');

      var accessToken = null;
      var tokenExpiresAt = 0;
      var uploadedPhotoId = null;

      function resetDropzoneText() {
        if (!dropzoneText || !fileInput) return;
        dropzoneText.innerHTML = fileInput.dataset.dropzoneDefault;
      }

      function showError(el, message) {
        if (!el) return;
        el.textContent = message;
        el.hidden = false;
      }

      function hideError(el) {
        if (!el) return;
        el.hidden = true;
        el.textContent = '';
      }

      function getToken() {
        // refresh 60s before actual expiry, not right at the edge
        var isFresh = accessToken && Date.now() < (tokenExpiresAt - 60000);
        if (isFresh) {
          return Promise.resolve(accessToken);
        }

        return fetch(tokenUrl, { method: 'POST' })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not get an upload token');
            return response.json();
          })
          .then(function (data) {
            accessToken = data.access_token;
            var expiresInMs = (data.expires_in || 1800) * 1000;
            tokenExpiresAt = Date.now() + expiresInMs;
            return accessToken;
          });
      }

      function uploadFile(file) {
        return getToken().then(function (token) {
          var formData = new FormData();
          formData.append('photo', file);

          return fetch(uploadUrl, {
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + token
            },
            body: formData
          });
        }).then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () {
              return {};
            }).then(function (errBody) {
              throw new Error(errBody.error || ('Photo upload failed (status ' + response.status + ')'));
            });
          }
          return response.json();
        }).then(function (data) {
          uploadedPhotoId = data.photo_id;
          return uploadedPhotoId;
        });
      }

      if (fileInput) {
        fileInput.addEventListener('change', function () {
          var file = fileInput.files && fileInput.files[0];
          hideError(uploadError);
          uploadedPhotoId = null;

          if (!file) return;

          if (file.size > MAX_PHOTO_BYTES) {
            showError(uploadError, 'That photo is over 20 MB — please choose a smaller file.');
            fileInput.value = '';
            return;
          }

          if (dropzoneText) {
            dropzoneText.innerHTML = 'Uploading&hellip;';
          }
          if (dropzone) dropzone.classList.add('sortabrick-sell-form__dropzone--busy');

          uploadFile(file).then(function () {
            if (dropzoneText) {
              dropzoneText.innerHTML = '<strong>' + file.name + '</strong> uploaded';
            }
            if (dropzone) dropzone.classList.remove('sortabrick-sell-form__dropzone--busy');
          }).catch(function (error) {
            console.error(error);
            showError(uploadError, error.message || 'Sorry, that photo could not be uploaded. Please try again.');
            resetDropzoneText();
            if (dropzone) dropzone.classList.remove('sortabrick-sell-form__dropzone--busy');
            fileInput.value = '';
          });
        });
      }

      function buildAddress(street, postalCode) {
        street = (street || '').trim();
        postalCode = (postalCode || '').trim();
        return postalCode ? street + ', ' + postalCode : street;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        hideError(submitError);
        if (submitSuccess) submitSuccess.hidden = true;

        if (!form.reportValidity()) return;

        if (!uploadedPhotoId) {
          showError(uploadError, 'Please add a photo of your bricks.');
          return;
        }

        if (!accessToken) {
          showError(submitError, 'Your upload session expired — please re-select your photo.');
          return;
        }

        var formData = new FormData(form);
        var payload = {
          photo_ids: [uploadedPhotoId],
          name: formData.get('first_name'),
          surname: formData.get('last_name'),
          email: formData.get('email'),
          phone: formData.get('phone'),
          weight: parseFloat(formData.get('weight_kg')),
          shipping_method: formData.get('shipping_method'),
          address: buildAddress(formData.get('street'), formData.get('postal_code')),
          city: formData.get('city'),
          country: formData.get('country'),
          iban: formData.get('iban'),
          message: formData.get('message') || undefined,
          lang: formData.get('lang') || 'en'
        };

        if (submitButton) submitButton.disabled = true;

        fetch(submitUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () {
              return {};
            }).then(function (errBody) {
              throw new Error(errBody.error || ('Submit failed (status ' + response.status + ')'));
            });
          }
          form.reset();
          uploadedPhotoId = null;
          resetDropzoneText();
          if (submitSuccess) submitSuccess.hidden = false;
        }).catch(function (error) {
          console.error(error);
          showError(submitError, error.message || 'Something went wrong submitting your form. Please try again.');
        }).finally(function () {
          if (submitButton) submitButton.disabled = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickSellFormV2);
  } else {
    initSortabrickSellFormV2();
  }
})();

/* Duplicate countdown into mobile collection grids */
function duplicateSortabrickCountdownInGrid() {
  var MIN_PRODUCTS = 8;
  var INSERT_AFTER = 4;
  var DUPLICATE_CLASS = 'sortabrick-countdown--grid-duplicate';

  function dedupeIds(root, suffix) {
    var idMap = {};
    root.querySelectorAll('[id]').forEach(function (el) {
      var newId = el.id + suffix;
      idMap[el.id] = newId;
      el.id = newId;
    });
    root.querySelectorAll('[for]').forEach(function (el) {
      var mapped = idMap[el.getAttribute('for')];
      if (mapped) el.setAttribute('for', mapped);
    });
    root.querySelectorAll('[aria-describedby]').forEach(function (el) {
      var mapped = idMap[el.getAttribute('aria-describedby')];
      if (mapped) el.setAttribute('aria-describedby', mapped);
    });
    root.querySelectorAll('[clip-path]').forEach(function (el) {
      var match = (el.getAttribute('clip-path') || '').match(/url\(#([^)]+)\)/);
      if (match && idMap[match[1]]) el.setAttribute('clip-path', 'url(#' + idMap[match[1]] + ')');
    });
  }

  var grid = document.querySelector('[data-testid="product-grid"]');
  var sourceRoot = document.querySelector('.sortabrick-countdown:not(.' + DUPLICATE_CLASS + ')');
  var sourceInner = sourceRoot && sourceRoot.querySelector('.sortabrick-countdown__inner');
  if (!grid) return;

  var existing = grid.querySelector('.' + DUPLICATE_CLASS);
  if (existing) existing.closest('.product-grid__item').remove();

  var items = grid.querySelectorAll('.product-grid__item');
  var shouldShow = window.matchMedia('(max-width: 749px)').matches && sourceRoot && sourceInner && items.length > MIN_PRODUCTS;
  if (!shouldShow) return;

  var targetItem = items[INSERT_AFTER - 1];
  if (!targetItem) return;

  var wrapper = document.createElement('li');
  wrapper.className = 'product-grid__item ' + DUPLICATE_CLASS + '-item';

  var countdownRoot = document.createElement('div');
  countdownRoot.className = 'sortabrick-countdown ' + DUPLICATE_CLASS;
  countdownRoot.dataset.targetDate = sourceRoot.dataset.targetDate;

  var clone = sourceInner.cloneNode(true);
  dedupeIds(clone, '-grid-dup');
  countdownRoot.appendChild(clone);
  wrapper.appendChild(countdownRoot);

  targetItem.insertAdjacentElement('afterend', wrapper);
  initSortabrickCountdown(countdownRoot);
}

(function () {
  var mediaQuery = window.matchMedia('(max-width: 749px)');

  function reapply(event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(duplicateSortabrickCountdownInGrid);
    } else {
      duplicateSortabrickCountdownInGrid();
    }
  }

  mediaQuery.addEventListener('change', duplicateSortabrickCountdownInGrid);
  document.addEventListener('shopify:search:update', reapply, true);
  document.addEventListener('shopify:collection:update', reapply, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', duplicateSortabrickCountdownInGrid);
  } else {
    duplicateSortabrickCountdownInGrid();
  }
})();

/* Switch ATC button if item is in cart */
(function () {
  function getVariantIdFromForm(root) {
    if (!root) return null;
    var input = root.querySelector('product-form-component input[name="id"]');
    return input ? input.value : null;
  }

  function variantQuantity(cart, variantId) {
    if (!variantId || !cart || !cart.items) return 0;
    var match = cart.items.filter(function (item) {
      return item.variant_id.toString() === variantId.toString();
    })[0];
    return match ? match.quantity : 0;
  }

  function toggleInCart(el, inCart) {
    if (inCart) {
      el.setAttribute('data-in-cart', 'true');
    } else {
      el.removeAttribute('data-in-cart');
    }
  }

  function setAddToCartBehavior(component, inCart) {
    var button = component.querySelector('button[ref="addToCartButton"]');
    if (!button) return;

    if (inCart) {
      button.type = 'button';
      button.removeAttribute('name');
      button.onclick = null;

      if (component.dataset.cartDrawerEnabled === 'true') {
        button.setAttribute('on:click', '#cart-drawer/toggle');
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'cart-drawer');
      } else {
        button.removeAttribute('on:click');
        button.removeAttribute('aria-haspopup');
        button.removeAttribute('aria-controls');
        button.onclick = function () {
          window.location.href = Theme.routes.cart_url;
        };
      }
    } else {
      button.type = 'submit';
      button.setAttribute('name', 'add');
      button.setAttribute('on:click', '/handleClick');
      button.removeAttribute('aria-haspopup');
      button.removeAttribute('aria-controls');
      button.onclick = null;
    }
  }

  function setStickyAddToCartBehavior(component, inCart) {
    var button = component.querySelector('button[ref="addToCartButton"]');
    if (!button) return;

    if (inCart) {
      button.onclick = null;

      if (component.dataset.cartDrawerEnabled === 'true') {
        button.setAttribute('on:click', '#cart-drawer/toggle');
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'cart-drawer');
      } else {
        button.removeAttribute('on:click');
        button.removeAttribute('aria-haspopup');
        button.removeAttribute('aria-controls');
        button.onclick = function () {
          window.location.href = Theme.routes.cart_url;
        };
      }
    } else {
      button.setAttribute('on:click', '/handleAddToCartClick');
      button.removeAttribute('aria-haspopup');
      button.removeAttribute('aria-controls');
      button.onclick = null;
    }
  }

  function applyInCartState(cart) {
    document.querySelectorAll('add-to-cart-component').forEach(function (el) {
      var variantId = getVariantIdFromForm(el.closest('form'));
      var inCart = variantQuantity(cart, variantId) > 0;
      toggleInCart(el, inCart);
      setAddToCartBehavior(el, inCart);
    });

    document.querySelectorAll('.sortabrick-add-to-cart-notice').forEach(function (el) {
      var variantId = getVariantIdFromForm(el.closest('.product-details'));
      toggleInCart(el, variantQuantity(cart, variantId) > 0);
    });

    document.querySelectorAll('.sortabrick-shipping').forEach(function (el) {
      var variantId = getVariantIdFromForm(el.closest('.product-details'));
      toggleInCart(el, variantQuantity(cart, variantId) > 0);
    });

    document.querySelectorAll('sticky-add-to-cart').forEach(function (el) {
      var variantId = el.dataset.currentVariantId;
      var inCart = variantQuantity(cart, variantId) > 0;
      toggleInCart(el, inCart);
      setStickyAddToCartBehavior(el, inCart);
    });
  }

  function refreshInCartState() {
    fetch(Theme.routes.cart_url + '.json', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(applyInCartState)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshInCartState);
  } else {
    refreshInCartState();
  }

  document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
    event.promise
      ?.then(function () {
        refreshInCartState();
      })
      .catch(function () {});
  });

  document.addEventListener(StandardEvents.productSelect, function () {
    refreshInCartState();
  });
})();

/* Sortabrick sell form (basic) */
(function () {
  function initSortabrickSellFormBasic() {
    var forms = document.querySelectorAll('[data-sortabrick-sell-form-basic]');

    forms.forEach(function (form) {
      var tokenUrl = form.dataset.tokenUrl;
      var submitUrl = form.dataset.submitUrl;

      var submitError = form.querySelector('[data-sortabrick-submit-error]');
      var submitSuccess = form.querySelector('[data-sortabrick-submit-success]');
      var submitButton = form.querySelector('[data-sortabrick-submit-button]');

      var accessToken = null;
      var tokenExpiresAt = 0;

      function showError(el, message) {
        if (!el) return;
        el.textContent = message;
        el.hidden = false;
      }

      function hideError(el) {
        if (!el) return;
        el.hidden = true;
        el.textContent = '';
      }

      function getToken() {
        var isFresh = accessToken && Date.now() < (tokenExpiresAt - 60000);
        if (isFresh) {
          return Promise.resolve(accessToken);
        }

        return fetch(tokenUrl, { method: 'POST' })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not get an upload token');
            return response.json();
          })
          .then(function (data) {
            accessToken = data.access_token;
            var expiresInMs = (data.expires_in || 1800) * 1000;
            tokenExpiresAt = Date.now() + expiresInMs;
            return accessToken;
          });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        hideError(submitError);
        if (submitSuccess) submitSuccess.hidden = true;

        if (!form.reportValidity()) return;

        var formData = new FormData(form);
        var weightRaw = formData.get('weight_kg');

        var payload = {
          name: formData.get('first_name'),
          surname: formData.get('last_name'),
          email: formData.get('email'),
          weight: weightRaw ? parseFloat(weightRaw) : undefined,
          lang: formData.get('lang') || 'en'
        };

        if (submitButton) submitButton.disabled = true;

        getToken().then(function (token) {
          return fetch(submitUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token
            },
            body: JSON.stringify(payload)
          });
        }).then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () {
              return {};
            }).then(function (errBody) {
              throw new Error(errBody.error || ('Submit failed (status ' + response.status + ')'));
            });
          }
          form.reset();
          if (submitSuccess) submitSuccess.hidden = false;
        }).catch(function (error) {
          console.error(error);
          showError(submitError, error.message || 'Something went wrong submitting your form. Please try again.');
        }).finally(function () {
          if (submitButton) submitButton.disabled = false;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortabrickSellFormBasic);
  } else {
    initSortabrickSellFormBasic();
  }
})();

/* Parts filter */
(function () {
  class SortabrickFacetRangeBucket extends HTMLElement {
    connectedCallback() {
      var input = this.querySelector('input[type="checkbox"]');
      if (!input || input.dataset.rangeBound === 'true') return;
      input.dataset.rangeBound = 'true';

      var wrapper = this.closest('[data-facet-range-wrapper]');
      var source = wrapper && wrapper.querySelector('[data-facet-range-source]');
      if (!source) return;

      var min = Number.parseFloat(input.dataset.rangeMin);
      var hasMax = input.dataset.rangeMax !== undefined && input.dataset.rangeMax !== '';
      var max = hasMax ? Number.parseFloat(input.dataset.rangeMax) : Infinity;
      if (Number.isNaN(min)) return;

      var members = Array.from(source.querySelectorAll('input[type="checkbox"]')).filter(function (member) {
        var raw = member.dataset.label !== undefined ? member.dataset.label : member.value;
        var value = Number.parseFloat(raw);
        return !Number.isNaN(value) && value >= min && value <= max;
      });

      input.indeterminate = input.dataset.indeterminate === 'true';

      input.addEventListener('change', function (event) {
        event.stopPropagation();

        var checked = input.checked;
        var changedMember = null;

        members.forEach(function (member) {
          if (member.disabled) return;
          if (member.checked !== checked) {
            member.checked = checked;
            if (!changedMember) changedMember = member;
          }
        });

        input.indeterminate = false;

        if (changedMember) {
          changedMember.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  if (!customElements.get('sortabrick-facet-range-bucket')) {
    customElements.define('sortabrick-facet-range-bucket', SortabrickFacetRangeBucket);
  }
})();

/* Year filter */
(function () {
  var TAG = 'sortabrick-facet-range-slider-component';

  function getState(component) {
    var wrapper = component.querySelector('[data-slider]');
    var minRange = component.querySelector('[data-slider-range="min"]');
    var maxRange = component.querySelector('[data-slider-range="max"]');
    var fill = component.querySelector('[data-slider-fill]');
    var minInput = component.querySelector('[data-slider-input="min"]');
    var maxInput = component.querySelector('[data-slider-input="max"]');
    if (!wrapper || !minRange || !maxRange || !fill || !minInput || !maxInput) return null;

    var boundsMin = Number.parseFloat(wrapper.dataset.sliderMin);
    var boundsMax = Number.parseFloat(wrapper.dataset.sliderMax);
    if (Number.isNaN(boundsMin) || Number.isNaN(boundsMax)) return null;

    return {
      minRange: minRange,
      maxRange: maxRange,
      fill: fill,
      minInput: minInput,
      maxInput: maxInput,
      boundsMin: boundsMin,
      boundsMax: boundsMax
    };
  }

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function updateFill(state) {
    var minVal = Number.parseFloat(state.minRange.value);
    var maxVal = Number.parseFloat(state.maxRange.value);
    if (minVal > maxVal) {
      var swap = state.minRange.value;
      state.minRange.value = state.maxRange.value;
      state.maxRange.value = swap;
      minVal = Number.parseFloat(state.minRange.value);
      maxVal = Number.parseFloat(state.maxRange.value);
    }
    var span = state.boundsMax - state.boundsMin;
    var minPercent = span ? ((minVal - state.boundsMin) / span) * 100 : 0;
    var maxPercent = span ? ((maxVal - state.boundsMin) / span) * 100 : 100;
    state.fill.style.left = minPercent + '%';
    state.fill.style.right = (100 - maxPercent) + '%';
    state.minRange.style.zIndex = minVal >= state.boundsMax ? 2 : 1;
  }

  function updateInputsDisplay(state) {
    state.minInput.value = state.minRange.value;
    state.maxInput.value = state.maxRange.value;
  }

  function applyRange(component, state) {
    var rangeWrapper = component.closest('[data-facet-range-wrapper]');
    var source = rangeWrapper && rangeWrapper.querySelector('[data-facet-range-source]');
    if (!source) return false;

    var currentMin = Number.parseFloat(state.minRange.value);
    var currentMax = Number.parseFloat(state.maxRange.value);
    var isFullRange = currentMin <= state.boundsMin && currentMax >= state.boundsMax;
    var changed = false;

    source.querySelectorAll('input[type="checkbox"]').forEach(function (member) {
      var raw = member.dataset.label !== undefined ? member.dataset.label : member.value;
      var value = Number.parseFloat(raw);
      if (Number.isNaN(value)) return;

      var shouldBeChecked = !isFullRange && value >= currentMin && value <= currentMax;
      if (shouldBeChecked) member.disabled = false;
      if (member.checked !== shouldBeChecked) {
        member.checked = shouldBeChecked;
        changed = true;
      }
    });

    return changed;
  }

  function findComponent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return null;
    return target.closest(TAG);
  }

  window.addEventListener('input', function (event) {
    var component = findComponent(event);
    if (!component || !event.target.hasAttribute('data-slider-range')) return;
    var state = getState(component);
    if (!state) return;
    updateFill(state);
    updateInputsDisplay(state);
  }, true);

  window.addEventListener('change', function (event) {
    var component = findComponent(event);
    if (!component) return;
    var state = getState(component);
    if (!state) return;

    var target = event.target;
    if (target.hasAttribute('data-slider-input')) {
      var isMin = target.dataset.sliderInput === 'min';
      var typed = Number.parseInt(target.value, 10);
      if (Number.isNaN(typed)) typed = isMin ? state.boundsMin : state.boundsMax;
      typed = clamp(typed, state.boundsMin, state.boundsMax);

      if (isMin) {
        state.minRange.value = typed;
        if (Number.parseFloat(state.maxRange.value) < typed) state.maxRange.value = typed;
      } else {
        state.maxRange.value = typed;
        if (Number.parseFloat(state.minRange.value) > typed) state.minRange.value = typed;
      }
    }

    updateFill(state);
    updateInputsDisplay(state);

    if (!applyRange(component, state)) event.stopPropagation();
  }, true);

  function refreshSliders() {
    document.querySelectorAll(TAG).forEach(function (component) {
      var state = getState(component);
      if (state) updateFill(state);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSliders);
  } else {
    refreshSliders();
  }

  function refreshAfterRender(event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(refreshSliders);
    } else {
      refreshSliders();
    }
  }

  document.addEventListener('theme-drawer:open', refreshSliders);
  document.addEventListener('shopify:search:update', refreshAfterRender, true);
  document.addEventListener('shopify:collection:update', refreshAfterRender, true);
})();